var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.slideActive.audioLink && !_vm.isBackstage)?_c('div',{staticClass:"audio-control horizontal layout"},[_c('audio',{ref:"audio-slide-tag",attrs:{"src":_vm.$store.state.slideActive.audioLink.url,"controls":"","preload":"auto","loop":_vm.$store.state.slideActive.audioRepeat}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }